import { InputType } from 'config'

export const defaultInputs = (): Record<string, Record<string, InputType>> => {
  return {
    creditReport: {
      section1: {
        inputType: 'section',
        title: 'Credit Report',
        span: 'full',
      },
      single: {
        title: 'Credit Report Default Cost Single Borrower Report',
        inputType: 'text',
        type: 'thousandSep',
        prefix: '$',
      },
      joint: {
        title: 'Credit Report Default Cost Joint Borrower Report',
        inputType: 'text',
        type: 'thousandSep',
        prefix: '$',
      },
    },
  }
}
